import type { TrendResponse } from "@meta-video/contracts";

type ReportingFingerprintSource = Pick<
  TrendResponse,
  | "attributionMaturityDays"
  | "coverage"
  | "effectiveRange"
  | "maturityCutoff"
  | "snapshotIdentity"
>;

export function reportingEnvelopeFingerprint(
  response: ReportingFingerprintSource,
): string {
  return JSON.stringify({
    attributionMaturityDays: response.attributionMaturityDays,
    snapshotIdentity: response.snapshotIdentity,
    coverage: response.coverage,
    effectiveRange: response.effectiveRange,
    maturityCutoff: response.maturityCutoff,
  });
}
